/* ============================================================
 * Gerüstexpress – Custom Product / Variant Logic
 * ============================================================
 *
 * Funktionen:
 * - Aktualisiert Preis bei Variantenwechsel
 * - Aktualisiert Streichpreis
 * - Aktualisiert "Sie sparen"
 * - Aktualisiert Netto-Preis
 * - Aktualisiert Netto-Streichpreis
 * - Aktualisiert SKU / Artikelnummer
 * - Behält SKU-Bezeichnung über data-sku-template bei
 * - Aktualisiert Variant-ID in der URL
 * - Erweitert Shopify Predictive Search um SKU
 * - Verhindert doppelte Updates derselben Variante
 *
 * WICHTIG:
 * Beim ersten Seitenaufruf wird die aktuell ausgewählte Variante
 * einmal geladen.
 *
 * Das ist notwendig, damit insbesondere:
 * - "Sie sparen" sofort erscheint
 * - Produkte ohne auswählbare Varianten korrekt funktionieren
 * - Netto-/Bruttopreise synchron sind
 *
 * Falls das Theme gleichzeitig Variant-Events auslöst,
 * wird ein doppeltes UI-Update verhindert.
 * ============================================================ */

(function () {
  'use strict';

  console.log('✅ Gerüstexpress custom.js loaded');

  // ============================================================
  // HELPERS
  // ============================================================

  function q(selector, root) {
    return (root || document).querySelector(selector);
  }

    function qa(selector, root) {
    return Array.prototype.slice.call(
      (root || getPriceRoot()).querySelectorAll(selector)
    );
  }

  // Begrenzt alle Preis-Updates auf den Hauptprodukt-Preisblock,
  // damit Empfehlungs-/Komplementaerkacheln nicht ueberschrieben werden.
  function getPriceRoot() {
    return document.querySelector('[data-product-pricing]') || document;
  }

  // ============================================================
  // AKTUELLE VARIANT-ID
  // ============================================================

  function getVariantId() {
    // Shopify Product Form
    var idInput = q(
      'form[action*="/cart/add"] select[name="id"], ' +
      'form[action*="/cart/add"] input[name="id"]:checked, ' +
      'form[action*="/cart/add"] input[name="id"][type="hidden"]'
    );

    if (idInput && idInput.value) {
      return String(idInput.value);
    }

    // Allgemeiner Fallback
    var genericIdInput = q('select[name="id"]');

    if (genericIdInput && genericIdInput.value) {
      return String(genericIdInput.value);
    }

    // Pixel Union / Empire Fallback
    var variantSelection = q('[data-variant-selection]');

    if (variantSelection) {
      var variantId =
        variantSelection.getAttribute('variant') ||
        variantSelection.getAttribute('data-variant');

      if (variantId) {
        return String(variantId);
      }
    }

    return null;
  }

  // ============================================================
  // PRODUCT JSON
  // ============================================================

  var productJsonUrl = null;

  // Produktdaten werden nach dem ersten erfolgreichen Abruf
  // zwischengespeichert.
  var productDataPromise = null;

  function getProductJsonUrl() {
    if (productJsonUrl) {
      return productJsonUrl;
    }

    var pathname =
      window.location.pathname.replace(/\/$/, '');

    productJsonUrl = pathname + '.js';

    return productJsonUrl;
  }

  function getProductData() {
    if (productDataPromise) {
      return productDataPromise;
    }

    productDataPromise = fetch(
      getProductJsonUrl(),
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Produktdaten konnten nicht geladen werden. HTTP ' +
            response.status
          );
        }

        return response.json();
      })
      .catch(function (error) {
        // Falls der Abruf fehlschlägt, darf beim nächsten Versuch
        // erneut geladen werden.
        productDataPromise = null;

        throw error;
      });

    return productDataPromise;
  }

  // ============================================================
  // MONEY FORMAT
  // ============================================================

  function formatMoney(cents) {
    if (
      cents === null ||
      cents === undefined ||
      cents === ''
    ) {
      return '';
    }

    var amount = Number(cents) / 100;

    if (!isFinite(amount)) {
      return '';
    }

    return amount.toLocaleString(
      'de-DE',
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    ) + ' €';
  }

  // ============================================================
  // MWST / NETTOPREIS
  // ============================================================

  function getVatPercentage() {
    var pricingDiv =
      q('[data-product-pricing]');

    if (pricingDiv) {
      var vat =
        pricingDiv.getAttribute('data-kg-vat');

      if (
        vat !== null &&
        vat !== ''
      ) {
        var parsedVat =
          parseFloat(vat);

        if (!isNaN(parsedVat)) {
          return parsedVat;
        }
      }
    }

    // Deutschland Fallback
    return 19;
  }

  function calculateNetPrice(
    gross,
    vatPercent
  ) {
    if (
      gross === null ||
      gross === undefined ||
      vatPercent === null ||
      vatPercent === undefined
    ) {
      return null;
    }

    var grossNumber =
      Number(gross);

    var vatNumber =
      Number(vatPercent);

    if (
      !isFinite(grossNumber) ||
      !isFinite(vatNumber)
    ) {
      return null;
    }

    var vatFactor =
      1 + vatNumber / 100;

    return Math.round(
      grossNumber / vatFactor
    );
  }

  // ============================================================
  // PREIS
  // ============================================================

  function updatePrice(variant) {
    if (
      variant.price === undefined ||
      variant.price === null
    ) {
      return;
    }

    qa('[data-price]').forEach(
      function (el) {
        el.textContent =
          formatMoney(variant.price);
      }
    );
  }

  // ============================================================
  // STREICHPREIS
  // ============================================================

  function updateCompareAtPrice(variant) {
    var price =
      Number(variant.price);

    var compareAtPrice =
      Number(
        variant.compare_at_price || 0
      );

    var onSale =
      compareAtPrice > 0 &&
      compareAtPrice > price;

    qa('[data-price-compare]').forEach(
      function (el) {
        if (onSale) {
          el.textContent =
            formatMoney(compareAtPrice);
        } else {
          el.textContent = '';
        }
      }
    );

    qa(
      '[data-price-compare-container]'
    ).forEach(
      function (el) {
        if (onSale) {
          el.classList.add('visible');

          el.style.removeProperty(
            'display'
          );
        } else {
          el.classList.remove(
            'visible'
          );

          el.style.display =
            'none';
        }
      }
    );
  }

  // ============================================================
  // "SIE SPAREN"
  // ============================================================

  function updateSavings(variant) {
    var price =
      Number(variant.price);

    var compareAtPrice =
      Number(
        variant.compare_at_price || 0
      );

    var onSale =
      compareAtPrice > 0 &&
      compareAtPrice > price;

    qa('[data-savings]').forEach(
      function (savingsEl) {
        if (!onSale) {
          savingsEl.style.display =
            'none';

          return;
        }

        var saved =
          compareAtPrice - price;

        var savedPercent =
          Math.round(
            (saved / compareAtPrice) *
            100
          );

        savingsEl.textContent =
          'Sie sparen ' +
          formatMoney(saved) +
          ' (' +
          savedPercent +
          '%)';

        savingsEl.style.removeProperty(
          'display'
        );
      }
    );
  }

  // ============================================================
  // NETTOPREIS
  // ============================================================

  function updateNetPrice(variant) {
    var vatPercent =
      getVatPercentage();

    var netPrice =
      calculateNetPrice(
        variant.price,
        vatPercent
      );

    if (netPrice === null) {
      return;
    }

    qa('[data-price-excl]').forEach(
      function (el) {
        el.textContent =
          formatMoney(netPrice);
      }
    );
  }

  // ============================================================
  // NETTO-STREICHPREIS
  // ============================================================

  function updateNetCompareAtPrice(
    variant
  ) {
    var price =
      Number(variant.price);

    var compareAtPrice =
      Number(
        variant.compare_at_price || 0
      );

    var onSale =
      compareAtPrice > 0 &&
      compareAtPrice > price;

    var elements =
      qa('[data-price-compare-excl]');

    if (!onSale) {
      elements.forEach(
        function (el) {
          el.textContent = '';
        }
      );

      return;
    }

    var vatPercent =
      getVatPercentage();

    var netCompareAtPrice =
      calculateNetPrice(
        compareAtPrice,
        vatPercent
      );

    if (
      netCompareAtPrice === null
    ) {
      return;
    }

    elements.forEach(
      function (el) {
        el.textContent =
          formatMoney(
            netCompareAtPrice
          );
      }
    );
  }

  // ============================================================
  // SKU / ARTIKELNUMMER
  // ============================================================

  function updateSku(variant) {
    var sku =
      variant.sku || '';

        qa('[data-sku-value]', document).forEach(
      function (skuEl) {
        /*
         * Beispiel aus Liquid:
         *
         * data-sku-template="Art.-Nr.: __SKU__"
         */

        var template =
          skuEl.getAttribute(
            'data-sku-template'
          );

        var skuContainer =
          skuEl.closest(
            '[data-sku-container]'
          );

        if (sku) {
          if (
            template &&
            template.indexOf(
              '__SKU__'
            ) !== -1
          ) {
            skuEl.textContent =
              template.replace(
                '__SKU__',
                sku
              );
          } else {
            /*
             * Fallback:
             * Falls data-sku-template
             * nicht vorhanden ist.
             */
            skuEl.textContent =
              'Art.-Nr.: ' + sku;
          }

          if (skuContainer) {
            skuContainer.classList.remove(
              'product-sku--empty'
            );
          }
        } else {
          skuEl.textContent = '';

          if (skuContainer) {
            skuContainer.classList.add(
              'product-sku--empty'
            );
          }
        }
      }
    );
  }

  // ============================================================
  // VARIANT-ID IN URL
  // ============================================================

  function updateVariantUrl(
    variantId
  ) {
    if (
      !variantId ||
      !window.history ||
      !window.history.replaceState
    ) {
      return;
    }

    try {
      var url =
        new URL(
          window.location.href
        );

      url.searchParams.set(
        'variant',
        String(variantId)
      );

      window.history.replaceState(
        {},
        '',
        url.pathname +
        url.search +
        url.hash
      );
    } catch (error) {
      console.warn(
        'Variant-URL konnte nicht aktualisiert werden:',
        error
      );
    }
  }

  // ============================================================
  // DOPPELTE UI-UPDATES VERHINDERN
  // ============================================================

  /*
   * Empire / Pixel Union kann beim Laden bzw. beim Wechsel
   * mehrere Events für dieselbe Variante auslösen.
   *
   * Zusätzlich führen wir beim Seitenstart selbst ein
   * Varianten-Update aus.
   *
   * Deshalb speichern wir eine Signatur der sichtbaren
   * Variantendaten.
   */

  var lastVariantSignature = null;

  function getVariantSignature(
    variant
  ) {
    if (!variant) {
      return null;
    }

    return [
      String(variant.id || ''),
      String(variant.price || ''),
      String(
        variant.compare_at_price || ''
      ),
      String(variant.sku || ''),

      /*
       * Wichtig:
       * undefined bleibt von false unterscheidbar.
       *
       * undefined -> ""
       * false     -> "false"
       * true      -> "true"
       */
      String(
        variant.available === undefined
          ? ''
          : variant.available
      )
    ].join('|');
  }

  // ============================================================
  // KOMPLETTES UI UPDATE
  // ============================================================

  function updateVariantDisplay(
    variant
  ) {
    if (
      !variant ||
      !variant.id
    ) {
      return;
    }

    var signature =
      getVariantSignature(variant);

    /*
     * Gleiche Variante mit identischen Daten
     * wurde bereits verarbeitet.
     */
    if (
      signature &&
      signature ===
        lastVariantSignature
    ) {
      return;
    }

    /*
     * Signatur vor dem UI-Update speichern.
     * Dadurch werden praktisch gleichzeitig
     * eintreffende Theme-Events ebenfalls
     * abgefangen.
     */
    lastVariantSignature =
      signature;

    updatePrice(
      variant
    );

    updateCompareAtPrice(
      variant
    );

    updateSavings(
      variant
    );

    updateNetPrice(
      variant
    );

    updateNetCompareAtPrice(
      variant
    );

    updateSku(
      variant
    );

    updateVariantUrl(
      variant.id
    );

    console.log(
      '✅ Variante aktualisiert:',
      {
        id:
          variant.id,

        sku:
          variant.sku || '',

        price:
          formatMoney(
            variant.price
          ),

        compareAtPrice:
          variant.compare_at_price
            ? formatMoney(
                variant.compare_at_price
              )
            : null,

        available:
          variant.available
      }
    );
  }

  // ============================================================
  // VARIANTE LADEN
  // ============================================================

  var currentRequestedVariantId =
    null;

  function fetchAndUpdateVariant(
    variantId
  ) {
    if (!variantId) {
      return;
    }

    variantId =
      String(variantId);

    /*
     * Derselbe Fetch läuft bereits.
     */
    if (
      currentRequestedVariantId ===
      variantId
    ) {
      return;
    }

    currentRequestedVariantId =
      variantId;

    getProductData()
      .then(
        function (productData) {
          if (
            !productData ||
            !Array.isArray(
              productData.variants
            )
          ) {
            throw new Error(
              'Keine Variantendaten gefunden.'
            );
          }

          var variant =
            productData.variants.find(
              function (item) {
                return (
                  String(item.id) ===
                  variantId
                );
              }
            );

          /*
           * Falls inzwischen eine andere
           * Variante ausgewählt wurde,
           * das alte Ergebnis ignorieren.
           */
          if (
            currentRequestedVariantId !==
            variantId
          ) {
            return;
          }

          if (!variant) {
            throw new Error(
              'Variante ' +
              variantId +
              ' wurde nicht gefunden.'
            );
          }

          updateVariantDisplay(
            variant
          );
        }
      )
      .catch(
        function (error) {
          console.error(
            '❌ Fehler beim Aktualisieren der Variante:',
            error
          );
        }
      )
      .finally(
        function () {
          if (
            currentRequestedVariantId ===
            variantId
          ) {
            currentRequestedVariantId =
              null;
          }
        }
      );
  }

  // ============================================================
  // DEBOUNCE
  // ============================================================

  var debounceTimer =
    null;

  function scheduleVariantUpdate() {
    if (debounceTimer) {
      clearTimeout(
        debounceTimer
      );
    }

    debounceTimer =
      setTimeout(
        function () {
          var variantId =
            getVariantId();

          if (variantId) {
            fetchAndUpdateVariant(
              variantId
            );
          }
        },
        75
      );
  }

  // ============================================================
  // STANDARD CHANGE EVENTS
  // ============================================================

  document.addEventListener(
    'change',
    function (event) {
      if (
        !event ||
        !event.target
      ) {
        return;
      }

      var target =
        event.target;

      // Pixel Union / Empire
      if (
        target.classList &&
        target.classList.contains(
          'options-selection__input-select'
        )
      ) {
        scheduleVariantUpdate();

        return;
      }

      // Standard Shopify Select
      if (
        target.matches &&
        target.matches(
          'select[name="id"]'
        )
      ) {
        fetchAndUpdateVariant(
          target.value
        );

        return;
      }

      // Standard Shopify Radio
      if (
        target.matches &&
        target.matches(
          'input[name="id"][type="radio"]'
        )
      ) {
        fetchAndUpdateVariant(
          target.value
        );

        return;
      }

      /*
       * Manche Themes ändern zunächst nur
       * einzelne Optionswerte und setzen
       * die endgültige Variant-ID kurz danach.
       */
      if (
        target.matches &&
        target.matches(
          '[name^="options["]'
        )
      ) {
        scheduleVariantUpdate();
      }
    }
  );

  // ============================================================
  // GEMEINSAMER THEME-VARIANT-HANDLER
  // ============================================================

  function handleVariantEvent(
    event
  ) {
    var variant =
      event &&
      event.detail &&
      event.detail.variant;

    if (
      !variant ||
      !variant.id
    ) {
      return;
    }

    /*
     * Wenn das Theme bereits vollständige
     * Variantendaten mitsendet, ist kein
     * zusätzlicher Produkt-Fetch notwendig.
     */
    if (
      variant.price !== undefined &&
      variant.price !== null
    ) {
      updateVariantDisplay(
        variant
      );

      return;
    }

    /*
     * Falls das Event nur die Variant-ID
     * enthält, laden wir die Daten aus
     * dem gecachten Product-JSON.
     */
    fetchAndUpdateVariant(
      String(variant.id)
    );
  }

  /*
   * Empire / Pixel Union bzw. andere Theme-Komponenten
   * können unterschiedliche Eventnamen verwenden.
   *
   * Beide Events nutzen denselben Handler.
   */
  [
    'variant-change',
    'variant:change'
  ].forEach(
    function (eventName) {
      document.addEventListener(
        eventName,
        handleVariantEvent
      );
    }
  );

  // ============================================================
  // SHOPIFY THEME EDITOR / SECTION RELOAD
  // ============================================================

  document.addEventListener(
    'shopify:section:load',
    function () {
      /*
       * Die Section wurde neu in den DOM geladen.
       * Deshalb dürfen Variantendaten erneut
       * verarbeitet werden.
       */

      lastVariantSignature =
        null;

      currentRequestedVariantId =
        null;

      /*
       * Kurzer DOM-Puffer nach dem Section-Reload,
       * damit neu gerenderte Formularelemente
       * verfügbar sind.
       *
       * Die 50 ms sind kein Shopify-Festwert,
       * sondern lediglich ein kleiner Sicherheits-Puffer.
       */
      setTimeout(
        function () {
          var variantId =
            getVariantId();

          if (variantId) {
            fetchAndUpdateVariant(
              variantId
            );
          }
        },
        50
      );
    }
  );


  // ============================================================
  // INITIALES VARIANTEN-UPDATE
  // ============================================================

  /*
   * Wird einmal beim Seitenaufruf ausgeführt.
   *
   * Dadurch funktioniert "Sie sparen" auch:
   * - ohne sichtbare Varianten-Auswahl
   * - bevor der Kunde etwas anklickt
   *
   * Falls Empire gleichzeitig ein Theme-Event sendet,
   * verhindert lastVariantSignature ein doppeltes
   * Rendern derselben Variantendaten.
   */

  var initialVariantId =
    getVariantId();

  if (initialVariantId) {
    fetchAndUpdateVariant(
      initialVariantId
    );
  }

})();